import useStore from "config/store";

export default function useCheckPermissions(requiredPermissions: string[]) {
  const userData = useStore(state => state.userData);
  const userPermissions = userData?.permissions || [];

  return requiredPermissions.every(perm => userPermissions.includes(perm)) || userData?.isSuperuser;
}
